module.exports = __webpack_public_path__ + "static/media/php.90cc5406.svg";